webpackJsonp([13994203391546835000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/Users/vysakh/docs/reactjs-sataiva/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-lodash/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-stage-0/lib/index.js\",\"/Users/vysakh/docs/reactjs-sataiva/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.jsx":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__("./node_modules/react-helmet/lib/Helmet.js");
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _CtaButton = __webpack_require__("./src/components/CtaButton.jsx");
	
	var _CtaButton2 = _interopRequireDefault(_CtaButton);
	
	var _MainLayout = __webpack_require__("./src/components/MainLayout.jsx");
	
	var _MainLayout2 = _interopRequireDefault(_MainLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_React$Component) {
	  _inherits(Index, _React$Component);
	
	  function Index() {
	    _classCallCheck(this, Index);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Index.prototype.render = function render() {
	    return _react2.default.createElement(
	      _MainLayout2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, { title: "Reactjs, Reduxjs introduction, tutorial for beginners and intermediates in 2018" }),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Quick Reactjs introduction"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "Hope you would have seen the reasons on why use Reactjs. If you are already a programmer who knows Java or C++ or python/Ruby, then you can learn reactjs through this tutorial in 9 mins."
	        ),
	        _react2.default.createElement(
	          _CtaButton2.default,
	          { to: '/react-intro/js-1' },
	          "Let's start with JS"
	        ),
	        _react2.default.createElement(
	          _CtaButton2.default,
	          { to: "/react-intro/dom" },
	          "Skip JS part"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Flying start with Redux"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "If you don't know if you should use redux, checkout ",
	          _react2.default.createElement(
	            "a",
	            { href: "https://medium.com/@dan_abramov/you-might-not-need-redux-be46360cf367" },
	            "this link."
	          ),
	          "You or your team has decided to go with redux and you know bit of reactjs. Then you can learn reduxjs through this tutorial in 14 mins. Sit tight"
	        ),
	        _react2.default.createElement(
	          _CtaButton2.default,
	          { to: '/redux-intro/library' },
	          "Let's go"
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h2",
	          null,
	          "Different features using Reactjs"
	        ),
	        _react2.default.createElement(
	          "p",
	          null,
	          "In most web applications, features like authentication, file upload, using external api, animation, payment gateway are the common features. We will see how to do each of them using Reactjs. This will be constantly updated."
	        ),
	        _react2.default.createElement(
	          _CtaButton2.default,
	          { to: '/redux-intro/library' },
	          "Let's go"
	        )
	      )
	    );
	  };
	
	  return Index;
	}(_react2.default.Component);
	
	exports.default = Index;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-fc530b42be133a957871.js